import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { timer, EMPTY } from 'rxjs';
import { scan, debounce, distinctUntilChanged } from 'rxjs/operators';
import { r as rjPlugin, o as RUN } from '../../rjPlugin.es.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toArray';
import '@babel/runtime/helpers/esm/typeof';
import 'object-path-immutable';
import '@babel/runtime/helpers/esm/defineProperty';

var defaultOptions = {
  time: 180
};

var rjDebounce = function rjDebounce() {
  var optionsOrTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var options;

  if (typeof optionsOrTime === 'number' && isFinite(optionsOrTime)) {
    options = {
      time: optionsOrTime
    };
  } else {
    options = _objectSpread(_objectSpread({}, defaultOptions), optionsOrTime);
  }

  return rjPlugin({
    actions: function actions(_ref) {
      var run = _ref.run;
      return {
        runDebounced: function runDebounced() {
          return run.apply(void 0, arguments).withMeta({
            debounced: true
          });
        }
      };
    },
    effectPipeline: function effectPipeline(actionObservable) {
      return actionObservable.pipe(scan(function (prev, current) {
        // Shoud debounce ma run?
        if (current.type === RUN && current.meta && current.meta.debounced && typeof options.when === 'function') {
          var shouldDebounce = options.when(prev ? prev.payload.params : null, current.payload.params);

          var newMeta = _objectSpread({}, current.meta);

          if (shouldDebounce) {
            newMeta.debounced = true;
          } else {
            newMeta.debounced = false;
          }

          return _objectSpread(_objectSpread({}, current), {}, {
            meta: newMeta
          });
        }

        return current;
      }, null), // The scan signature T
      debounce(function (action) {
        if (action.type === RUN && action.meta.debounced) {
          return timer(options.time);
        } else {
          return EMPTY;
        }
      }), distinctUntilChanged(function (prevAction, currAction) {
        // not same stuff
        if (currAction.type !== prevAction.type) {
          return false;
        } // Ignore not debounced actions...


        if (currAction.type !== RUN || !currAction.meta.debounced) {
          return false;
        } // cant be the same


        if (currAction.payload.params.length !== prevAction.payload.params.length) {
          return false;
        } // TODO: Maybe deep compare at 1 level depth of plain objects
        // compare params


        for (var i = 0; i < currAction.payload.params.length; i++) {
          if (currAction.payload.params[i] !== prevAction.payload.params[i]) {
            return false;
          }
        } // the same action =)


        return true;
      }));
    }
  });
};

export default rjDebounce;
